import { type Decoder, string, union } from 'io-ts/lib/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const KnownTags = iotsUtils.fromList(constants.time.timeline.knownTags);

type _KnownTags = (typeof constants.time.timeline.knownTags)[number];
type _Tag = _KnownTags | (string & {});

export const Tag = union(KnownTags, string) as Decoder<unknown, _Tag>;
